import { StyledButton } from '@tryhackme/thm-ui-components';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useUsername } from 'src/common/hooks/use-username';
import { Achievement, SocialName } from 'src/common/page-share';
import { socialTrackEvents } from 'src/common/page-share/page-share.constants';
import { useSocialLinks } from 'src/common/page-share/use-social-links';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledSocialButton } from 'src/common/styles';
import type { SegmentShareEvent } from 'src/common/types';
import { useGetBadgesQuery } from 'src/features/badges/badges.slice';
import { StyledWrapperButtons } from '../../completion-modal.styles';
import type { SocialSharingProps } from './social-sharing.types';
export const SocialSharing = ({
  roomType,
  roomCode,
  isCompletionShareRoomModal,
  socialLinks = {
    [SocialName.twitter]: true,
    [SocialName.facebook]: true,
    [SocialName.linkedin]: true
  }
}: SocialSharingProps) => {
  const {
    data: badgesData
  } = useGetBadgesQuery();
  const username = useUsername();
  const [trackEvent] = useTrackEventMutation();
  const awardedBadge = badgesData?.data?.badges?.find(badge => badge.name === roomCode);
  const filteredLinks = useSocialLinks(socialLinks);
  const trackShareClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        room_type: roomType,
        page: 'room',
        achievement: Achievement.room,
        name: roomCode ?? '',
        medium: source,
        clicked_on: isCompletionShareRoomModal ? 'roombanner-cta' : source
      }
    });
  }, [trackEvent, roomCode, isCompletionShareRoomModal, roomType]);
  return <StyledWrapperButtons data-sentry-element="StyledWrapperButtons" data-sentry-component="SocialSharing" data-sentry-source-file="social-sharing.tsx">
      {awardedBadge && <StyledButton as={Link} to={`/p/${username || ''}`} variant="solid" color="primary" target="_blank">
          Share Awarded Badge
        </StyledButton>}
      {filteredLinks.map(social => <StyledSocialButton key={social.name} data-social={social.name} href={social.href({
      description: 'Share your achievement',
      url: `https://tryhackme.com/room/${roomCode}`,
      campaign: {
        utmContent: 'utmContent'
      }
    })} target="_blank" onClick={() => trackShareClick(socialTrackEvents[social.name])}>
          <social.icon />
          {social.name}
        </StyledSocialButton>)}
    </StyledWrapperButtons>;
};